import { css, keyframes } from '@emotion/react'
import styled from '@emotion/styled'

export const StepWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 24px;
  padding: 48px 20px 0;
  flex: 1;
`

export const QuestionCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 40px 24px 36px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 2px 24px 0 rgba(0, 0, 0, 0.04);
`

export const QuestionText = styled.p`
  font-size: 26px;
  font-weight: 700;
  color: #1b1c1d;
  text-align: center;
  line-height: 2.25rem;
  letter-spacing: -0.0244rem;
  word-break: keep-all;
  white-space: pre-line;
`

export const QuestionImage = styled.img`
  width: 100%;
  max-height: 200px;
  object-fit: contain;
  border-radius: 8px;
`

export const ButtonRow = styled.div`
  display: flex;
  gap: 12px;
`

const btnPress = keyframes`
  0%   { transform: scale(1); }
  30%  { transform: scale(0.92); }
  60%  { transform: scale(1.04); }
  100% { transform: scale(1); }
`

const rippleExpand = keyframes`
  0%   { width: 0; height: 0; opacity: 0.35; }
  100% { width: 500px; height: 500px; opacity: 0; }
`

export const Ripple = styled.span`
  position: absolute;
  width: 0;
  height: 0;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  opacity: 0;
  background: rgba(255, 255, 255, 0.4);
`

export const AnswerButton = styled('button', {
  shouldForwardProp: (prop) => prop !== 'isCorrect' && prop !== 'isPressed',
})<{ isCorrect: boolean; isPressed?: boolean }>`
  flex: 1;
  height: 64px;
  background-color: ${({ isCorrect }) => (isCorrect ? '#3b82f6' : '#ef4444')};
  border: none;
  border-radius: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  -webkit-tap-highlight-color: transparent;

  svg {
    path {
      fill: #ffffff;
    }
  }

  ${({ isPressed }) =>
    isPressed &&
    css`
      animation: ${btnPress} 0.35s ease-out;

      .ripple {
        animation: ${rippleExpand} 0.5s ease-out forwards;
      }
    `}
`
